module.exports = __webpack_public_path__ + "img/generate-03.54eab33e.png";